import { useState } from "react";
import { TextField } from "@mui/material";
import { validateEmailMatch } from "../../../../Helpers/InputValidationHelpers";
import "./EmailInput.scss";

export interface EmailInputProps {
	change: (result: { value: string; valid: boolean; error: string }) => void;
}

export const EmailInput = ({ change }: EmailInputProps) => {
	const [email, setEmail] = useState("");
	const [emailRepeat, setEmailRepeat] = useState("");
	const [emailTouched, setEmailTouched] = useState(false);
	const [repeatTouched, setRepeatTouched] = useState(false);
	const [errors, setErrors] = useState<string[]>([]);

	const handleBlur = (field: "email" | "repeat") => {
		if (field === "email") setEmailTouched(true);
		if (field === "repeat") setRepeatTouched(true);

		const errs = validateEmailMatch(email, emailRepeat);
		setErrors(errs);

		const valid = errs.length === 0 && email.length > 0;
		change({ value: email, valid, error: errs.join(", ") });
	};

	const showErrors = emailTouched && repeatTouched && errors.length > 0;

	return (
		<div className="email-input-root">
			<TextField
				variant="outlined"
				label="Indtast E-mail"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				onBlur={() => handleBlur("email")}
				error={showErrors}
				fullWidth
			/>
			<TextField
				variant="outlined"
				label="Gentag E-mail"
				value={emailRepeat}
				onChange={(e) => setEmailRepeat(e.target.value)}
				onBlur={() => handleBlur("repeat")}
				error={showErrors}
				fullWidth
			/>
			{showErrors && (
				<div className="email-input-errors">
					<ul>
						{errors.map((err) => (
							<li key={err}>{err}</li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
};

export default EmailInput;
